import { all, fork } from "redux-saga/effects";
import API from '../Services/Api'
import authSaga from "./AuthSagas";
import dubbingSaga from "./DubbingSagas";

/* ------------- API ------------- */

const api = API.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    fork(authSaga, api),
    fork(dubbingSaga, api),
  ]);
}
